import Vue from 'vue';

const success = (response, context) => {
    toastr.success(response.data.msg);
    context.loading = false;
    Vue.router.push({
        name: 'account.team',
    });
};

const failed = (error, context) => {
    context.showToasterError(error);
    context.loading = false;
};

export default (member, context) => Vue.$http.put(`/team-members/${member.id}`, member).then((response) => {
  if (response && response.status === 200) {
    success(response, context);
  }
}).catch((error) => {
  failed(error, context);
});



// WEBPACK FOOTER //
// ./src/app/services/team_member/update.js